module.exports = __webpack_public_path__ + "img/malta.dac11acf.svg";